module.exports = __webpack_public_path__ + "img/164.8c5ab1c0.jpg";